// Pages/ProductPage/BulkOrderPanle.js
export function BulkOrderPanel({ rawText, onRawTextChange, onParse }) {
  return (
    <>
      <textarea
        value={rawText}
        onChange={e => onRawTextChange(e.target.value)}
        rows={8}
      />
      <button onClick={onParse}>Parse</button>
    </>
  );
}
